import {context} from '../app-context/AppContext';
import {RepositoryFilters, RepositoryParams} from './repository';
import {HttpServiceResponse} from '../http/http';

export abstract class AbstractRepository<T, RawResource = any> {
    protected defaultFilters: RepositoryFilters;
    protected filters: RepositoryFilters = {};
    protected apiUrl: string;

    constructor({apiUrl, defaultFilters = {}}: RepositoryParams) {
        this.apiUrl = apiUrl;
        this.defaultFilters = defaultFilters;
    }

    async get(): Promise<HttpServiceResponse<T>> {
        const [data, error] = await context.httpService.get<RawResource>(this.apiUrl);

        if (error) {
            return [null, error];
        }

        if (typeof data !== 'object' || !data) {
            throw new Error(`${this.constructor.name}.get (${this.apiUrl}): not an Object: ${data}`);
        }

        return [this.resourceBuilder(data), error];
    }

    async getAllElements(): Promise<HttpServiceResponse<T[]>> {
        const [data, error] = await context.httpService.get(this.apiUrl);

        if (error) {
            return [null, error];
        }

        if (!Array.isArray(data)) {
            let dataString = data;
            if (typeof data === 'object') {
                try {
                    dataString = JSON.stringify(data);
                } catch (e) {
                    // not JSONable, do nothing
                }
            }
            throw new Error(`${this.constructor.name}.getAllElements (${this.apiUrl}): not an Array: ${dataString}`);
        }

        return [data.map((it: RawResource) => this.resourceBuilder(it)), error];
    }

    async getByRef(ref: string): Promise<HttpServiceResponse<T>> {
        const [data, error] = await context.httpService.get<RawResource>(ref);

        if (error) {
            return [null, error];
        }

        if (typeof data !== 'object' || !data) {
            throw new Error(`${this.constructor.name}.getByRef (${this.apiUrl}): not an Object: ${data}`);
        }

        return [this.resourceBuilder(data), error];
    }

    protected abstract resourceBuilder(data: RawResource): T;
}
